import React from 'react'
import { Box, Text } from 'theme-ui'

export default function NotFound() {
  return (
    <Box
      sx={{
        width: '100%',
        height: 8,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <Box>
        <Text as="h1" sx={{ fontSize: 6 }}>
          404
        </Text>
      </Box>
      <Text as="h1">PAGE NOT FOUND</Text>
    </Box>
  )
}
